var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"dealer"},[_c('ul',{staticClass:"flex f-wrap f-between"},_vm._l((_vm.dealerData),function(item,index){return _c('li',{staticClass:"list"},[_c('p',{staticClass:"f24 fw-b col666"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.num))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3d4295f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = n1cy
// module chunks = 1